import { render } from "./SupplierDetail.vue?vue&type=template&id=818e7d8e&scoped=true"
import script from "./SupplierDetail.vue?vue&type=script&lang=js"
export * from "./SupplierDetail.vue?vue&type=script&lang=js"

import "./SupplierDetail.vue?vue&type=style&index=0&id=818e7d8e&lang=less&scoped=true"

import exportComponent from "/Users/longliu/Desktop/projects/povertyalleviation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-818e7d8e"]])

export default __exports__